export default {
	props: {
		label: {
			type: String,
			required: true
		},

		placeholder: {
			type: String,
			required: false,
			default: ''
		},

		value: {
			required: false,
			default: {
				model: '',
				errors: {},
				validator: {}
			}
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		mensagemInformacao: {
			type: String,
			required: false,
			default: ''
		}
	},
	computed: {
		obrigatorio() {
			return this.value?.validator?.required
		},
		mensagemErro() {
			return this.value?.errors?.errorMsg
		}
	},
	methods: {
		emitValue(evento, valor) {
			this.$emit(evento, {...this.value, model: valor})
		}
	}
}
